import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class NoAuthorizationInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('api/reload') >= 0 || !req.url.startsWith('http')) {
      const headers = req.headers.delete('Authorization');
      req = req.clone({
        headers
      });
    }
    return next.handle(req);
  }
}
